const isQuestionnaireQuestion = (item) => {
    if (!item || typeof item !== "object" || Array.isArray(item)) {
        return false;
    }

    return Boolean(
        item.title
        && (item.answer !== undefined || Array.isArray(item.options) || item.type)
    );
};

const isMetadataReport = (item) => {
    if (!item || typeof item !== "object" || Array.isArray(item)) {
        return false;
    }

    return !isQuestionnaireQuestion(item)
        && (
            item.status !== undefined
            || item.requestDate !== undefined
            || item.submissionDate !== undefined
            || item.reportType !== undefined
        );
};

const normalizeQuestionnaireReports = (reports = []) => {
    if (!Array.isArray(reports) || !reports.length) {
        return [];
    }

    if (Array.isArray(reports[0])) {
        return reports.filter(
            (reportSet) => Array.isArray(reportSet) && reportSet.some(isQuestionnaireQuestion)
        );
    }

    if (reports.some(isQuestionnaireQuestion)) {
        return [reports.filter(isQuestionnaireQuestion)];
    }

    return [];
};

const normalizeMetadataReports = (reports = []) => {
    if (!Array.isArray(reports) || !reports.length) {
        return [];
    }

    if (Array.isArray(reports[0]) || reports.some(isQuestionnaireQuestion)) {
        return [];
    }

    return reports.filter(isMetadataReport);
};

export {
    isQuestionnaireQuestion,
    normalizeQuestionnaireReports,
    normalizeMetadataReports,
};
